import { render, staticRenderFns } from "./ImgDetail.vue?vue&type=template&id=90eb1e36&scoped=true&"
import script from "./ImgDetail.vue?vue&type=script&lang=js&"
export * from "./ImgDetail.vue?vue&type=script&lang=js&"
import style0 from "./ImgDetail.vue?vue&type=style&index=0&id=90eb1e36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90eb1e36",
  null
  
)

export default component.exports